module.exports = __webpack_public_path__ + "img/report.1b6cd5e2.svg";